import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
                <div className="text-slate-500 text-sm">Проверка авторизации...</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
